/**
 * Home Page Component
 *
 * Landing page that displays search, products, magazine, and news
 */

import React from "react";
import { APP_CONFIG } from "../configs/config";
import { useUserData } from "../hooks/useUserData";
import Header from "../components/layout/Header";
import SpecialOfferBanner from "../components/layout/SpecialOfferBanner";
import SearchPage from "../components/pages/SearchPage";
import ProductIntro from "../components/products/ProductIntro";
import Magazine from "../components/pages/Magazine";
import NewsPage from "../components/pages/NewsPage";
import Footer from "../components/layout/Footer";

const HomePage = ({ suggestions }) => {
  const { getHeaderProps } = useUserData();

  return (
    <>
      <Header {...getHeaderProps()} logoUrl={APP_CONFIG.LOGO_URL} />
      <SpecialOfferBanner />
      <SearchPage suggestions={suggestions} />
      <ProductIntro />
      <Magazine />
      <NewsPage />
      <Footer logoUrl={APP_CONFIG.LOGO_URL} />
    </>
  );
};

export default HomePage;
